export default __webpack_public_path__ + "static/media/r5.15b4a042.png";